import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Mesmo padrão visual de LogLevelChip/FeedbackBadges (bolinha + texto).
const STATUS_CONFIG = {
  ok: { label: 'OK', bg: '#E8F5E9', border: '#C8E6C9', dot: '#2E7D32', text: '#2E7D32' },
  error: { label: 'Erro', bg: '#FFEBEE', border: '#FFCDD2', dot: '#E53935', text: '#C62828' },
  late: { label: 'Atrasada', bg: '#FFF3E0', border: '#FFE0B2', dot: '#FB8C00', text: '#E65100' },
  running: { label: 'Rodando', bg: '#E3F2FD', border: '#BBDEFB', dot: '#1E88E5', text: '#1565C0' },
  stale_lock: { label: 'Lock preso', bg: '#FFEBEE', border: '#FFCDD2', dot: '#E53935', text: '#C62828' },
  never: { label: 'Sem registro', bg: '#F5F5F5', border: '#E0E0E0', dot: '#9E9E9E', text: '#616161' },
};

/**
 * CronStatusChip - Indicador de resultado da última execução de uma rotina (Admin Geral > Rotinas)
 * @param {Object} props
 * @param {string} props.status - 'ok'|'error'|'late'|'running'|'stale_lock'|'never'
 */
function CronStatusChip({ status }) {
  const cfg = STATUS_CONFIG[status] || { label: status || '—', bg: '#F5F5F5', border: '#E0E0E0', dot: '#9E9E9E', text: '#616161' };

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.6,
        px: 1.25,
        py: 0.4,
        borderRadius: '20px',
        backgroundColor: cfg.bg,
        border: `1px solid ${cfg.border}`,
        width: 'fit-content',
      }}
    >
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: cfg.dot, flexShrink: 0 }} />
      <Typography
        variant="caption"
        sx={{ fontWeight: 500, fontSize: '0.75rem', lineHeight: 1, color: cfg.text, whiteSpace: 'nowrap' }}
      >
        {cfg.label}
      </Typography>
    </Box>
  );
}

export default CronStatusChip;
